export default {
  SET_LOGS: function (state, payloads) {
    state.logs = payloads;
  }
}
